import { useMutation } from "@tanstack/react-query";
import { timestampToLocalTime } from "anka-endeavour";
import { Button, Card, Col, Descriptions, Divider, Drawer, Form, Input, message, Radio, Row, Skeleton, List } from "antd";
import axios from "axios";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { hostname } from "../hooks/useEndeavour";
import Status from "./Status";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import Title from "antd/es/typography/Title";

const UserContactDrawer = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const [type, setType] = useState("email");
  const [loading, setLoading] = useState(false);
  const [multiple, setMultiple] = useState(false);
  const [messageId, setMessageId] = useState(null);
  const [userID, setUserID] = useState();
  const [value, setValue] = useState('');
  const [mode, setMode] = useState('text');

  const user = useMutation({
    mutationFn: (data) => {
      return axios
        .get(`${hostname}/pa-alliance/user/${data}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          setCurrentUser(res.data.payload);
          setLoading(false);
        });
    },
  });

  const contactUser = useMutation({
    mutationFn: (data) => {
      return axios
        .post(`${hostname}/pa-alliance/user/contact`, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          message.success("User contacted successfully!");
          closeDrawer();
          props.setSelected([]);
          props.onChange();
        })
        .catch((err) => {
          setLoading(false);
          if (err.response && typeof err.response.data.error.message === "string") {
            message.error(err.response.data.error.message);
          } else {
            message.error(err.response.data.error.message);
            message.error("Something went wrong.");
          }
        });
    },
  });

  const onFinish = () => {
    form.validateFields().then((values) => {
      if (multiple === true) {
        let selected = currentUser.map((data) => data.email);
        values.email = selected;
        values.id = currentUser.map((data) => data.id);
      } else {
        values.email = [currentUser?.email];
        values.id = [currentUser?.id];
      }
      if (messageId !== null) {
        values.message_id = messageId;
      }
      setLoading(true);
      contactUser.mutate(values);
    });
  };

  const openDrawer = (data, multiple, setSelected = null, messageId = null) => {
    if (multiple === true) {
      setMultiple(true);
      setCurrentUser(data);
    } else {
      user.mutate(data);
      setMessageId(messageId);
    }
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
    setLoading(false);
    form.resetFields();
    setCurrentUser();
    setMultiple(false);
    setMessageId(null);
    setMode('text');
  };

  useImperativeHandle(ref, () => ({
    openDrawer,
  }));

  const template = (value) => {
    switch (value) {
      case "hello":
        if (type === "email") {
          form.setFieldValue("subject", "Hello");
        }
        form.validateFields;
        form.setFieldValue("content", "Hello");
        break;
      case "email":
        if (type === "email") {
          form.setFieldValue("subject", "Email Validate");
        }
        form.setFieldValue("content", "Hi Sir \nSeem there have not validate the email. May i know xxxxxxx");
        break;
      case "mobile":
        if (type === "email") {
          form.setFieldValue("subject", "Mobile Validate");
        }
        form.setFieldValue("content", "Hi Sir \nSeem there have not validate the mobile. May i know xxxxxxx");
        break;
      default:
        form.resetFields();
    }
  };

  const removeList = (data) => {
    return () => {
      const list = currentUser.filter((item) => item.email !== data.email);
      setCurrentUser(list);
    };
  };

  return (
    <Drawer title="User Information" open={open} onClose={closeDrawer} width={800} styles={{ wrapper: { borderRadius: 12 } }}>
      {/* {console.log(currentUser)} */}
      <Row gutter={[16, 16]}>
        {multiple === true && (
          <Col span={24}>
            <Card title="Selected User">
              <List
                dataSource={currentUser}
                renderItem={(item) => (
                  <List.Item key={item.uuid}>
                    <List.Item.Meta title={item.email} />
                    <Button type="primary" danger onClick={removeList(item)}>
                      Delete
                    </Button>
                  </List.Item>
                )}
              />
            </Card>
          </Col>
        )}

        {currentUser === null && multiple === false && <Skeleton />}
        {currentUser !== null && multiple === false && (
          <>
            <Col span={24}>
              <Descriptions column={2} layout="vertical">
                <Descriptions.Item label="User">{currentUser?.email}</Descriptions.Item>
                {/* <Descriptions.Item label="Status">{currentUser?.status !== null && <Status value={currentUser?.status} />}</Descriptions.Item> */}
                <Descriptions.Item label="Registration Time">{timestampToLocalTime(currentUser?.created_at)}</Descriptions.Item>
                <Descriptions.Item label="Last Contact Time">{timestampToLocalTime(currentUser?.contacted_at)}</Descriptions.Item>
                <Descriptions.Item label="Contact Status">
                  {currentUser?.contact_status !== null && currentUser?.contact_status !== undefined ? (
                    <Status value={currentUser?.contact_status} />
                  ) : (
                    <Status value={"pending"} />
                  )}
                </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col span={24}>
              <Divider orientation="left" plain>
                Verification Status
              </Divider>
              <Descriptions layout="vertical">
                <Descriptions.Item label="Email">
                  {currentUser?.email_verified !== null ? (
                    <Status value={currentUser?.email_verified === false ? "FAILED" : "SUCCESS"} />
                  ) : (
                    <Status value={"FAILED"} />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="Mobile">
                  {currentUser?.mobile_verified !== null ? (
                    <Status value={currentUser?.mobile_verified === false ? "FAILED" : "SUCCESS"} />
                  ) : (
                    <Status value={"FAILED"} />
                  )}
                </Descriptions.Item>
                <Descriptions.Item label="EKYC">
                  {currentUser?.kyc_id !== null ? (
                    <Status value={currentUser?.kyc_id === false ? "FAILED" : "SUCCESS"} />
                  ) : (
                    <Status value={"FAILED"} />
                  )}
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </>
        )}
        <Col span={24}>
          <Descriptions layout="vertical"></Descriptions>
          <Divider orientation="left" plain></Divider>
          <Card title=" Contact User">
            <Form
              layout="vertical"
              form={form}
              onFinish={onFinish}
              initialValues={{ status: "hello", type: "email", record: true, conversation_status: "processing", content_mode: 'text' }}
            >
              <Form.Item
                label="Status"
                name={"status"}
                rules={[
                  {
                    required: true,
                    message: "Please select Status !",
                  },
                ]}
                onChange={(e) => {
                  if (e.target.value === "closed") {
                    form.setFieldValue("conversation_status", "closed");
                  } else {
                    form.setFieldValue("conversation_status", "processing");
                  }
                }}
              >
                <Radio.Group
                  defaultValue={"hello"}
                  options={[
                    {
                      value: "hello",
                      label: "Hello",
                    },

                    {
                      value: "follow_up",
                      label: "Follow Up",
                    },

                    {
                      value: "no_reply",
                      label: "No Reply",
                    },
                    {
                      value: "escalate",
                      label: "Escalate",
                    },
                    { value: "campaign", label: "Campaign" },
                    { value: "closed", label: "Closed" },
                  ]}
                />
              </Form.Item>

              <Form.Item
                label="Conversation Status"
                name={"conversation_status"}
                rules={[
                  {
                    required: true,
                    message: "Please select Conversation Status!",
                  },
                ]}
              >
                <Radio.Group
                  // defaultValue={"processing"}
                  options={[
                    { value: "processing", label: "Processing" },
                    { value: "closed", label: "Closed" },
                  ]}
                />
              </Form.Item>



              <Form.Item
                label="Contact Method"
                name={"type"}
                rules={[
                  {
                    required: true,
                    message: "Please select Content Method !",
                  },
                ]}
              >
                <Radio.Group
                  defaultValue={"email"}
                  options={[
                    {
                      value: "email",
                      label: "Email",
                    },

                    {
                      value: "telegram",
                      label: "Telegram",
                    },

                    {
                      value: "whatsapp",
                      label: "WhatsApp",
                    },
                    {
                      value: "wechat",
                      label: "Wechat",
                    },
                    {
                      value: "sms",
                      label: "SMS",
                    },
                  ]}
                  onChange={(e) => {
                    setType(e.target.value);
                  }}
                />
              </Form.Item>

              <Form.Item label="Content Mode" name={'content_mode'} required={true}>
                <Radio.Group
                  options={[
                    { label: "Text", value: 'text' },
                    { label: "Html", value: 'html' },
                  ]}
                  onChange={(e) => {
                    setMode(e.target.value);
                    if (e.target.value === 'text') {
                      form.setFieldValue("content2", "");
                      setValue('');
                    } else {
                      form.setFieldValue("content", '');
                      setValue('');
                    }
                  }}
                />

              </Form.Item>

              {type === "email" && (
                <>
                  <Form.Item
                    name={"record"}
                    label="Record"
                    rules={[
                      {
                        required: true,
                        message: "Please select Radio !",
                      },
                    ]}
                  >
                    <Radio.Group
                      defaultValue={true}
                      options={[
                        { label: "Yes", value: true },
                        { label: "No", value: false },
                      ]}
                    />
                  </Form.Item>
                  <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[
                      {
                        required: true,
                        message: "Please input Subject!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                </>
              )}



              {mode === 'text' ?
                <Form.Item label="Content" name="content"
                  rules={[
                    {
                      required: true,
                      message: "Please input Content !",
                    },
                  ]}
                >
                  <Input.TextArea rows={9} />
                </Form.Item>
                :
                <Form.Item label="Content" name="content" rules={[
                  {
                    required: true,
                    message: "Please input Content!",
                  },
                ]} >
                  <ReactQuill theme="snow" value={value} onChange={setValue} style={{ height: 180, marginBottom: 50 }} />
                </Form.Item>
              }

              <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Col>
      </Row>
    </Drawer>
  );
});

export default UserContactDrawer;
